import 'aos/dist/aos.css';

const AboutSection = () => {
  return (
    <section className="about padding-top--style2 padding-bottom bg-color-3 pb-5">
      <div className="graph-background"></div>
      <div className="container content-box">
        <div className="about__wrapper">
          <div className="row align-items-center">
            <div className="section-header text-center mb-0">
              <h2 className="text-uppercase">Who we<span className="style2"> are</span></h2>
            </div>

            <div className="col-lg-5">
              <div className="about__thumb about__thumb--style2" data-aos="fade-left" data-aos-duration="800">
                <div className="about__thumb-inner mt-30 mt-lg-0">
                  <div className="about__thumb-image text-center">
                    <img src="assets/images/new/who-are-we-img.png" alt="about-image" className="dark" />
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-lg-7">
              <div className="about__content about__content--style2" data-aos="fade-right" data-aos-duration="1000">
                <div className="about__content-inner">
                  <div className="about__content-details">
                    <p >
                      <strong>Asiatic Stock & Securities Ltd.</strong>  has been a trusted name in India's capital 
                      markets for decades. We have been a proud member of the National Stock Exchange of India  since 1995 
                      and member of the Bombay Stock Exchange .
                    </p>
                    <p className="mb-0">For over 30 years, we have maintained a complaint-free and litigation-free 
                      records testament to our unwavering commitment to Integrity, transparency, and client satisfaction. 
                      Whether you are a long-term investor, quantitative trader, or short-term market participant, 
                      we offer the expertise, tools, and personalized service to help you grow and succeed in today's 
                      dynamic markets.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="trust-section py-4 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-4">
              Why <span className="style2">Us </span>?
            </h2>

            <div className="grid md:grid-cols-3 gap-8">
              {/* Trust */}
              <div className="why-us-item trust-item duration-300 mb-3">
                <div className="trust-icon"> 
                  <i className="fas fa-handshake" style={{ color: 'rgb(10, 79, 213)' }}></i> 
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Trust</h3>
                <p className="text-gray-600 leading-relaxed">
                  Backed by SEBI registration, decades of ethical market presence, and
                  transparent client relationships that inspire lasting confidence.
                </p>
              </div>

              {/* Experience */}
              <div className="why-us-item trust-item duration-300 mb-3">
                <div className="trust-icon"> 
                  <i className="fas fa-chart-line" style={{ color: 'rgb(10, 79, 213)' }}></i> 
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Experience</h3>
                <p className="text-gray-600 leading-relaxed">
                  With 35+ years in Indian capital markets, our leadership blends deep
                  domain expertise with modern trading innovation.
                </p>
              </div>

              {/* Compliance */}
              <div className="why-us-item trust-item duration-300 mb-3">
                <div className="trust-icon"> 
                  <i className="fas fa-shield-alt" style={{ color: 'rgb(10, 79, 213)' }}></i> 
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Compliance</h3>
                <p className="text-gray-600 leading-relaxed">
                  Fully aligned with SEBI, NSE, and BSE standards ensuring every trade,
                  strategy, and report meets the highest regulatory benchmarks.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutSection;